export default {
  strict: true,
  namespaced: true,
  state: {
    services: {}
  },
  mutations: {
    setLyftData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/lyft.js